import type { UrlStatusUpdate } from '@kanbu/schema/contracts';

import { UrlList } from '@/components/url-list/url-list';
import { Wrapper } from '@/components/wrapper/wrapper';

interface KnownSourcesSectionProps {
  urlStatusUpdates: UrlStatusUpdate[];
}

export function KnownSourcesSection({
  urlStatusUpdates,
}: KnownSourcesSectionProps) {
  return (
    <Wrapper title='Zdroje, které znám'>
      <UrlList urls={urlStatusUpdates} isLoading={false} />
    </Wrapper>
  );
}
